// @ts-nocheck
import React from 'react';
import TerritoryLink from '../../../common/links/TerritoryLink';
import SkuRestrictions from '../../../sku/components/SkuRestrictions';
import { useTranslation } from 'react-i18next';

export interface TerritoryRowProps {
  game: any;
  style: React.CSSProperties;
}

function TerritoryRow({ game, style }: TerritoryRowProps) {
  const { t } = useTranslation();
  return (
    <div className="grid-empty" style={style}>
      {game.isSKU && (
        <div className="restrictions">
          <SkuRestrictions
            isDisallow={!game?.territoriesRestricted}
            restrictions={game?.territories}
            noDataText={t('No restrictions')}
            render={({ id, name, colour }: any) => (
              <TerritoryLink
                id={id}
                key={id}
                name={name}
                colour={colour}
              ></TerritoryLink>
            )}
          ></SkuRestrictions>
        </div>
      )}
    </div>
  );
}

export default TerritoryRow;
